import { useEffect, useRef, useState } from 'react';
import { useScrollRoot } from '../../context/ScrollContext';
import './ScrollReveal.css';

function ScrollReveal({ children, index = 0, className = '' }) {
  const elementRef = useRef(null);
  const scrollRootRef = useScrollRoot();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(element);
        }
      },
      {
        root: scrollRootRef?.current ?? null,
        rootMargin: '0px 0px -6% 0px',
        threshold: 0.08,
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [scrollRootRef, index]);

  return (
    <div
      ref={elementRef}
      className={`scroll-reveal${isVisible ? ' scroll-reveal--visible' : ''} ${className}`.trim()}
      style={{ '--reveal-index': index }}
    >
      {children}
    </div>
  );
}

export default ScrollReveal;
